import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const responseSchema = yup.array().of(
  yup.object({
    id: yup.number().required(),
    question: yup.string().required(),
  }),
);

export const useUserSecurityQuestionsQuery = (options = {}) => {
  return useQuery(
    [QUERY_KEYS.userSecurityQuestions],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.user.getSecurityQuestions());
      return responseSchema.validateSync(res?.data?.data, {
        strict: true,
      });
    },
    options,
  );
};
